// Quick Add to Cart function using Shopify's AJAX API
function quickAddToCart(event, variantId, button, imageUrl) {
  // Prevent event bubbling to product link
  event.preventDefault();
  event.stopPropagation();

  // Prevent multiple clicks
  if (button.disabled) return;

  console.log('quickAddToCart called', { variantId, imageUrl });

  // Trigger FlyToCart animation if image URL is provided
  if (imageUrl) {
    const cartIcon = document.querySelector('.header-actions__cart-icon') || document.querySelector('#cart-icon-bubble');
    console.log('Cart icon found:', cartIcon);
    
    if (cartIcon) {
      if (!customElements.get('fly-to-cart')) {
        console.error('FlyToCart custom element is not defined! Ensure product-form.js is loaded.');
      } else {
        console.log('Creating fly-to-cart element');
        const flyToCartElement = document.createElement('fly-to-cart');
        flyToCartElement.style.setProperty('background-image', `url(${imageUrl})`);
        flyToCartElement.source = button;
        flyToCartElement.destination = cartIcon;
        document.body.appendChild(flyToCartElement);
      }
    } else {
      console.warn('Cart icon not found, skipping animation');
    }
  } else {
    console.warn('No image URL provided for animation');
  }

  // Disable button and show loading state
  button.disabled = true;
  const originalHTML = button.innerHTML;
  button.innerHTML = '<svg width="18" height="18" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="16" r="10"/><path d="m12 16 3 3 6-6"/></svg>';

  // Use theme's exact approach - FormData not JSON
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  formData.append('sections', 'cart-icon-bubble,cart-drawer,cart-live-region-text');
  formData.append('sections_url', window.location.pathname);

  // Use theme's exact headers
  const config = {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/javascript'
    },
    body: formData
  };

  fetch('/cart/add.js', config)
  .then(response => response.json())
  .then(response => {
    if (response.status) {
      alert(response.message || 'Error adding to cart');
      button.disabled = false;
      button.innerHTML = originalHTML;
      return;
    }

    // Show success state
    button.innerHTML = '<svg width="18" height="18" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="8 16 14 22 24 10"/></svg>';

    // Dispatch CartAddEvent exactly like the theme does
    const cartAddEvent = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: response,
        sourceId: 'quick-add-button-' + variantId,
        data: {
          source: 'quick-add-image-button',
          didError: false,
          itemCount: response.quantity || 1,
          variantId: variantId,
          productId: variantId,
          sections: response.sections
        }
      }
    });

    document.dispatchEvent(cartAddEvent);

    // Reset button after delay
    setTimeout(() => {
      button.disabled = false;
      button.innerHTML = originalHTML;
    }, 1500);

  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    alert('Error adding to cart');
    button.disabled = false;
    button.innerHTML = originalHTML;
  });
}

// Update cart UI components
function updateCartComponents(cartData) {
  // Update cart icon bubble
  if (cartData.sections && cartData.sections['cart-icon-bubble']) {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = cartData.sections['cart-icon-bubble'];
      const newBubble = tempDiv.querySelector('#cart-icon-bubble');
      if (newBubble) {
        cartIconBubble.innerHTML = newBubble.innerHTML;
      }
    }
  }

  // Update cart drawer
  if (cartData.sections && cartData.sections['cart-drawer']) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = cartData.sections['cart-drawer'];
      const newDrawer = tempDiv.querySelector('cart-drawer');
      if (newDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
      }
    }
  }

  // Trigger cart update event
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));

  // Publish to Shopify's theme system if available
  if (window.Shopify && window.Shopify.publish) {
    window.Shopify.publish(CartUpdateEvent.eventName, {
      data: cartData,
      source: 'quick-add-image-button'
    });
  }
}

// Dispatch CartAddEvent to trigger cart drawer auto-open and other listeners
function dispatchCartAddEvent(cartData) {
  // Create custom event that matches the theme's CartAddEvent
  const cartAddEvent = new CustomEvent('cart:add', {
    detail: {
      data: cartData,
      source: 'quick-add-image-button',
      didError: false,
      itemCount: cartData.quantity || 1
    },
    bubbles: true
  });

  // Dispatch the event
  document.dispatchEvent(cartAddEvent);

  // Also try to trigger cart drawer update directly
  updateCartDrawer(cartData);
}

// Update cart drawer content
function updateCartDrawer(cartData) {
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer && cartData.sections && cartData.sections['cart-drawer']) {
    // Update the cart drawer content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = cartData.sections['cart-drawer'];

    // Find and update the cart items
    const newCartItems = tempDiv.querySelector('cart-items-component');
    const currentCartItems = cartDrawer.querySelector('cart-items-component');

    if (newCartItems && currentCartItems) {
      currentCartItems.innerHTML = newCartItems.innerHTML;
    }

    // Update cart empty state
    const newDrawer = tempDiv.querySelector('cart-drawer-component');
    if (newDrawer && cartDrawer) {
      if (newDrawer.classList.contains('cart-drawer--empty')) {
        cartDrawer.classList.add('cart-drawer--empty');
      } else {
        cartDrawer.classList.remove('cart-drawer--empty');
      }
    }

    // Open the cart drawer after updating
    setTimeout(() => {
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else if (typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
      }
    }, 100);
  }
}

// Open cart drawer using multiple methods (fallback)
function openCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer) {
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return true;
    } else if (typeof cartDrawer.showDialog === 'function') {
      cartDrawer.showDialog();
      return true;
    }
  }

  // Fallback: try cart icon click
  const cartIcon = document.querySelector('button[on\\:click*="/open"], .header-actions__action');
  if (cartIcon) {
    cartIcon.click();
    return true;
  }

  return false;
}
